'use client'

import React from 'react'

import { MButton } from '../../../../components/button'
import { cn } from '../../../../utils/cn'

import type { IButtonProps } from '../../../../components/button/m-button'

export interface ITextAButtonsProps {
	buttons: IButtonProps[]
	className?: string
}

export const TextAButtons: React.FC<ITextAButtonsProps> = ({ buttons, className }) => {
	if (buttons.length === 0) return null
	return (
		<div className={cn('m-text-a__buttons', className)}>
			{buttons.map((btn, i) => (
				<MButton key={i} {...btn} />
			))}
		</div>
	)
}

TextAButtons.displayName = 'ATextAButtons'
